import { Capacitor } from "@capacitor/core";

/**
 * Location accuracy priority levels.
 */
export enum LocationAccuracyPriority {
  HIGH_ACCURACY = 4,
}

/**
 * Requests high-accuracy location from the device.
 * On Android, this prompts the user to enable GPS if it's not already on.
 * On iOS, this is a no-op as iOS manages location accuracy differently.
 * On web, this throws an error as it's not supported.
 *
 * @param priority - The location accuracy priority level
 */
export async function requestLocationAccuracy(
  priority: LocationAccuracyPriority = LocationAccuracyPriority.HIGH_ACCURACY
): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    throw new Error("requestLocationAccuracy is only available on native platforms");
  }

  const { LocationAccuracy } = await import("@ionic-native/location-accuracy");
  await LocationAccuracy.request(priority);
}
